const ModalVideo = function () {
    
    const YouTubeGetID = function (url) {
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }

    // get id youtube or vimeo
    function parseVideo(url) {
        // - Supported YouTube URL formats:
        //   - http://www.youtube.com/watch?v=xxxxxx
        //   - http://youtu.be/xxxxxx
        //   - https://youtube.googleapis.com/v/xxxxxx
        // - Supported Vimeo URL formats:
        //   - http://vimeo.com/xxxxxx
        //   - http://player.vimeo.com/video/xxxxxx
        // - Also supports relative URLs:
        //   - //player.vimeo.com/video/xxxxxx
  
        url.match(/(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
  
        if (RegExp.$3.indexOf('youtu') > -1) {
            var type = 'youtube';
        } else if (RegExp.$3.indexOf('vimeo') > -1) {
            var type = 'vimeo';
        }
  
        return {
            type: type,
            id: RegExp.$6
        };
    }

    const boxVideo = function (el, status) {
        var iframeyt = $("#video-yt");
        var videoYT = el;


        if (status == 1) {
            iframeyt.attr('src', '');
        } else {
            var videosrc = videoYT.attr('data-src');
            var timToPlay = 0;

            // verifica se é vimeo
            if ( parseVideo(videosrc).type == 'vimeo' ) {

                console.log(parseVideo(videosrc).id);
                iframeyt.attr('src', `https://player.vimeo.com/video/${parseVideo(videosrc).id}?autoplay=1`);

            } else {

                if (videosrc.indexOf('start=')) {
                    timToPlay = videosrc.split('start=')[1];
                }
                if (videosrc.indexOf('t=')) {
                    timToPlay = videosrc.split('t=')[1];
                }

                timToPlay = parseInt(timToPlay);
                iframeyt.attr('src', "https://www.youtube.com/embed/" + parseVideo(videosrc).id + "?start=" + timToPlay + "&rel=0&autoplay=1");

            }

        }

        var $modalSearch = $("#modal-video");
        $modalSearch.fadeToggle(200);
    }



    const closeModal = function (el) {
        if (el.attr('data-modal') == "modal") {

            el.closest('.elm-modal').fadeOut(100);

        } else {
            boxVideo(el, 1);// close video
        }
    }

    return {
        init: function () {

            if (!document.querySelectorAll('.playBtn').length > 0) {
                return;
            }

            $(document).on("click", ".playBtn", function () {
                boxVideo($(this))
            });
            $(document).on("click", ".s-close", function () {
                closeModal($(this));
            });
        }
    }

}();

module.exports = ModalVideo;